import moment from 'moment';

import { LANG_EN_SLUG, TNullableString } from '@common/types/common';

export const genCurrentTimeString = (): string => {
  const now: Date = new Date();
  return `${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}:${now.getMilliseconds()}`;
};

export const buildFullName = (
  titleBeforeName: TNullableString,
  firstName: TNullableString,
  lastName: TNullableString,
  titleAfterName: TNullableString,
): string => {
  return [titleBeforeName, firstName, lastName, titleAfterName]
    .join(' ')
    .trim();
};

export const buildString = (...args: string[]) => args.join(' ');

export const getDateFormat = (): string =>
  moment.locale() === LANG_EN_SLUG ? 'Do MMM YYYY ' : 'D. MMMM YYYY';

export const getTimeFormat = (withSeconds = true): string =>
  withSeconds ? 'HH:mm:ss' : 'HH:mm';

export const getDateTimeFormat = (): string =>
  `${getDateFormat()} ${getTimeFormat()}`;

export const isEmptyOrWhiteSpace = (str: string) => str.trim().length <= 0;
